import React from 'react'
import { useTranslation } from 'react-i18next';

interface Text {
  fr : string
  en : string
}
interface ItemService {
    id: number
    title: Text
    description: Text
    image: string
}

const Services = ({items}) => {
  const { t, i18n } = useTranslation();
  
    function itemService(item:ItemService) {
        return(
            <div key={item.id} className="col-lg-4">
                {/* <!-- service card --> */}
                <div className="knsl-ath-card knsl-scroll-animation">
                  <div className="knsl-cover-frame">
                    <img src={item.image} alt={`${item.title[i18n.language]} - The West Heaven Hotel`} />
                  </div>
                  <div className="knsl-card-description">
                    <h3 className="knsl-mb-10">{item.title[i18n.language]}</h3>
                    <p>{item.description[i18n.language]}</p>
                    <button className="knsl-btn">{t('main.readMore')}</button>
                  </div>
                </div>
                {/* <!-- service card end --> */}
            </div>
        )
    }

    return (
        <section className="knsl-p-100-80" id='services'>
          <div className="container">
            <div className="row">
              <div className="col-lg-12">

                <div className="knsl-center knsl-title-frame knsl-scroll-animation knsl-mb-100">
                  <h2 className="knsl-mb-20">{t('main.aroundHotel')}</h2>
                  <p className="knsl-mb-30">{t('main.aroundHotelDesc')}</p>
                  <button className="knsl-btn knsl-btn-md">{t('main.services')}</button>
                </div>

              </div>
              {items.map((item:ItemService) => itemService(item))}
            </div>
          </div>
        </section>
    )
}

export default Services